export default {
  baseStyle: {
    my: 0,
    color: 'fg',
  },
  variants: {
    normal: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    supporting: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    small: {
      fontSize: '12px',
      lineHeight: '16px',
    },
    tiny: {
      fontSize: '10px',
      lineHeight: '14px',
    },
    eyebrow: {
      color: 'fg.subtle',
      fontSize: '14px',
      lineHeight: '17px',
      textTransform: 'uppercase',
      letterSpacing: 1,
      fontWeight: 600,
    },
    'eyebrow-small': {
      color: 'fg.subtle',
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      letterSpacing: 1,
      fontWeight: 600,
    },
    'body-title-large': {
      color: 'fg',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 600,
    },
  },

  defaultProps: {
    variant: 'normal',
  },
}
